import uploadsarticlesbestDuiLawyerInElkGroveimagelawOfficeDeskLegalDocumentsGavelJpg from "$lib/data/generated/uploads/articles/best-dui-lawyer-in-elk-grove/image/law-office-desk-legal-documents-gavel.jpg";

export const uploads = {
  "uploads/articles/best-dui-lawyer-in-elk-grove/image/law-office-desk-legal-documents-gavel.jpg": uploadsarticlesbestDuiLawyerInElkGroveimagelawOfficeDeskLegalDocumentsGavelJpg
};